import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {
  CitizensUploadableFormRequest,
  CitizensUploadableFormRequestInput
} from './citizens-uploadable-form-request.model';

export const loadCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] Load CitizensUploadableFormRequests',
  props<{ citizensUploadableFormRequests: CitizensUploadableFormRequest[] }>()
);

export const addCitizensUploadableFormRequest = createAction(
  '[CitizensUploadableFormRequest/API] Add CitizensUploadableFormRequest',
  props<{ citizensUploadableFormRequest: CitizensUploadableFormRequest }>()
);

export const upsertCitizensUploadableFormRequest = createAction(
  '[CitizensUploadableFormRequest/API] Upsert CitizensUploadableFormRequest',
  props<{ citizensUploadableFormRequest: CitizensUploadableFormRequest }>()
);

export const addCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] Add CitizensUploadableFormRequests',
  props<{ citizensUploadableFormRequests: CitizensUploadableFormRequest[] }>()
);

export const upsertCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] Upsert CitizensUploadableFormRequests',
  props<{ citizensUploadableFormRequests: CitizensUploadableFormRequest[] }>()
);

export const updateCitizensUploadableFormRequest = createAction(
  '[CitizensUploadableFormRequest/API] Update CitizensUploadableFormRequest',
  props<{ citizensUploadableFormRequest: Update<CitizensUploadableFormRequest> }>()
);

export const updateCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] Update CitizensUploadableFormRequests',
  props<{ citizensUploadableFormRequests: Update<CitizensUploadableFormRequest>[] }>()
);

export const deleteCitizensUploadableFormRequest = createAction(
  '[CitizensUploadableFormRequest/API] Delete CitizensUploadableFormRequest',
  props<{ id: string }>()
);

export const deleteCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] Delete CitizensUploadableFormRequests',
  props<{ ids: string[] }>()
);

export const clearCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] Clear CitizensUploadableFormRequests'
);


// CUSTOM
export const createCitizensUploadableFormRequests = createAction(
  '[CitizensUploadableFormRequest/API] create CitizensUploadableFormRequests',
  props<{ input: CitizensUploadableFormRequestInput }>()
);
